import { render, staticRenderFns } from "./InquiriesPage.vue?vue&type=template&id=dbb132f6&"
import script from "./InquiriesPage.vue?vue&type=script&lang=js&"
export * from "./InquiriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports